import { render, staticRenderFns } from "./FormatInput.vue?vue&type=template&id=3a5e1cce&scoped=true"
import script from "./FormatInput.vue?vue&type=script&lang=js"
export * from "./FormatInput.vue?vue&type=script&lang=js"
import style0 from "./FormatInput.vue?vue&type=style&index=0&id=3a5e1cce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5e1cce",
  null
  
)

export default component.exports